import { QueryFactory } from "../../../../Common";
export const QGetEventsByEventIdForBetSlip = QueryFactory("GetEventsByEventIdForBetSlip");
//# sourceMappingURL=QGetEventsByEventIdForBetSlip.js.map